import { FunctionComponent, useEffect } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import * as api from './services/api';

import { 
  Drug, 
  Landing, 
  ForgotPassword, 
  Login, 
  SignUp,
  ResetPassword, 
  Upload,
  MedicalImaging,
  MRI,
  PET,
  XRay,
  OCT,
  Fundus,
  RetinalVideo,
  PupilVideo,
  CT,
  Ultrasonic,
  Surgical,
  Reasoning,
  Gene,
  AdminUsers,
  AdminHealth
} from './pages';
import AuthGuard from './components/AuthGuard';
import store from './store';

// Ping backend to record frontend visit (for admin "all visits" map)
const App: FunctionComponent = () => {
    useEffect(() => {
        api.visitPing().catch(() => {});
    }, []);
    return (
        <Provider store={store}>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/drugs" element={<Drug />} />
                    <Route path="/gene" element={<Gene />} />
                    <Route path="/medical_imaging" element={<MedicalImaging />} />
                    <Route path="/medical_imaging/mri" element={<MRI />} />
                    <Route path="/medical_imaging/pet" element={<PET />} />
                    <Route path="/medical_imaging/xray" element={<XRay />} />
                    <Route path="/medical_imaging/oct" element={<OCT />} />
                    <Route path="/medical_imaging/fundus" element={<Fundus />} />
                    <Route path="/medical_imaging/retinal_video" element={<RetinalVideo />} />
                    <Route path="/medical_imaging/pupil_video" element={<PupilVideo />} />
                    <Route path="/medical_imaging/ct" element={<CT />} />
                    <Route path="/medical_imaging/ultrasonic" element={<Ultrasonic />} />
                    <Route path="/medical_imaging/surgical" element={<Surgical />} />
                    <Route path="/reasoning" element={
                        <AuthGuard>
                            <Reasoning />
                        </AuthGuard>
                    } />
                    <Route path="/login" element={<Login />} />
                    <Route path="/signup" element={<SignUp />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/reset-password" element={<ResetPassword />} />
                    <Route path="/upload" element={<Upload />} />
                    <Route path="/admin/users" element={
                        <AuthGuard>
                            <AdminUsers />
                        </AuthGuard>
                    } />
                    <Route path="/admin/health" element={
                        <AuthGuard>
                            <AdminHealth />
                        </AuthGuard>
                    } />
                </Routes>
            </BrowserRouter>
        </Provider>
    );
};

export default App;
